export const DOCUMENT_SHIPPING_INVALIDATED_EVENT =
  "gomake:document-shipping-invalidated";

export interface DocumentShippingInvalidatedDetail {
  documentId: string;
  documentType: string | number;
}

const normalizeDocumentTypeKey = (
  value: string | number | null | undefined,
): string | null => {
  if (value == null) {
    return null;
  }

  const raw = String(value).trim().toLowerCase();
  if (raw === "quote" || raw === "0") {
    return "quote";
  }
  if (raw === "order" || raw === "1") {
    return "order";
  }

  return raw;
};

export const documentShippingKeysMatch = (
  leftDocumentId: string | null | undefined,
  leftDocumentType: string | null | undefined,
  rightDocumentId: string | null | undefined,
  rightDocumentType: string | number | null | undefined,
): boolean => {
  if (!leftDocumentId || !rightDocumentId) {
    return false;
  }

  const leftType = normalizeDocumentTypeKey(leftDocumentType);
  const rightType = normalizeDocumentTypeKey(rightDocumentType);

  return (
    String(leftDocumentId) === String(rightDocumentId) &&
    leftType != null &&
    rightType != null &&
    leftType === rightType
  );
};

export const notifyDocumentShippingInvalidated = (
  detail: DocumentShippingInvalidatedDetail,
): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<DocumentShippingInvalidatedDetail>(
      DOCUMENT_SHIPPING_INVALIDATED_EVENT,
      { detail },
    ),
  );
};
